/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const oil = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.617 10.728h4.976M8.667 7.417h4.471m0 0a6.098 6.098 0 0 0-.654-1.127L8.168.75c-.36 0-4.319 5.54-4.319 5.54a6.106 6.106 0 0 0-1.182 3.612 5.5 5.5 0 0 0 9.389 3.89c.936-1.076 1.315-1.785 1.537-3.064.016-.17.074-.653.074-.826a6.1 6.1 0 0 0-.529-2.485Z"
    />
  </svg>
)
export default oil
